import { render, staticRenderFns } from "./form.vue?vue&type=template&id=238f6cfe&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=238f6cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f6cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('238f6cfe')) {
      api.createRecord('238f6cfe', component.options)
    } else {
      api.reload('238f6cfe', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=238f6cfe&scoped=true&", function () {
      api.rerender('238f6cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommend/compoments/form.vue"
export default component.exports